import React from 'react';

const Support: React.FC<{ language: 'tr' | 'en' }> = ({ language }) => {
  const formData = {
    name: '',
    email: '',
    message: '',
  };

  const [form, setForm] = React.useState(formData);
  const [submitted, setSubmitted] = React.useState(false); // Gönderim durumu için state

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form Submitted:', form);
    setForm(formData);
    setSubmitted(true); // Form gönderildiğinde gönderildi yazısını göstermek için state güncellenir
  };

  return (
    <div className="p-8 max-w-4xl mx-auto">
      {language === 'tr' ? (
        <div>
          <h1 className="text-4xl font-bold mb-6">Destek</h1>
          <p className="mb-4">Herhangi bir sorunla karşılaştığınızda veya yardıma ihtiyaç duyduğunuzda lütfen bizimle iletişime geçin. Aşağıdaki formu doldurarak bize ulaşabilirsiniz.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-lg font-medium mb-2">İsim</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-lg font-medium mb-2">E-posta</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                required
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-lg font-medium mb-2">Mesajınız</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                rows={6}
                required
              />
            </div>
            <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
              Gönder
            </button>
            {submitted && (
              <p className="text-green-500 mt-4">Mesajınız başarıyla gönderildi!</p>
            )}
          </form>
        </div>
      ) : (
        <div>
          <h1 className="text-4xl font-bold mb-6">Support</h1>
          <p className="mb-4">If you encounter any issues or need assistance, please contact us. You can reach us by filling out the form below.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-lg font-medium mb-2">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-lg font-medium mb-2">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                required
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-lg font-medium mb-2">Your Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                rows={6}
                required
              />
            </div>
            <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
              Submit
            </button>
            {submitted && (
              <p className="text-green-500 mt-4">Your message has been successfully sent!</p>
            )}
          </form>
        </div>
      )}
    </div>
  );
};

export default Support;
